module.exports = __webpack_public_path__ + "static/media/professional-doctor-radiologist-medical-laboratory-1.56f6d884.webp";